/**
 * Display the current tracker name for copy stored before the rename.
 *
 * This is intentionally narrow. It changes only retired product names and
 * leaves real class names such as "Fall Production" untouched. Firestore is
 * never rewritten, so cached clients and old reminder records stay compatible.
 */
export function recitalCompTrackerCopy(value: unknown): string {
  if (typeof value !== 'string') return '';
  return value.replace(
    /(?:Comp\/Recital Tracker|Production Tracker|Recital\/Comp Due Dates)/gi,
    'Recital/Comp Tracker'
  );
}
